import styled from "styled-components";

export const StyledCheckboxContainer = styled.div`
  .ant-row {
    gap: 6px;
    flex-direction: row-reverse;

    & label::after {
      display: none;
    }

    .ant-form-item-control-input-content {
      translate: 0px 3px;
    }
  }
`;
StyledCheckboxContainer.displayName = "StyledCheckboxContainer";
